"use client";
import { useTransition } from "react";
import { setUiLanguageAction } from "./actions";
import { useLocale, useT } from "./client";
import { UI_LOCALES, UI_LOCALE_NAMES } from "./config";

/** Dashboard language selector. Persists the choice, then re-renders the page in the new language (and direction). */
export function LanguageSwitcher({ className, tone = "light" }: { className?: string; tone?: "light" | "dark" }) {
  const locale = useLocale();
  const t = useT();
  const [pending, start] = useTransition();
  return (
    <label className={className}>
      <span className="sr-only">{t("nav.language")}</span>
      <select
        aria-label={t("nav.language")}
        value={locale}
        disabled={pending}
        data-testid="ui-language"
        onChange={(e) => {
          const next = e.target.value;
          start(async () => {
            const r = await setUiLanguageAction(next);
            if (r.ok) {
              document.documentElement.lang = next;
              document.documentElement.dir = next === "ar" ? "rtl" : "ltr";
              // Full reload: every server-rendered screen (and cached client data) re-renders in the new language.
              window.location.reload();
            }
          });
        }}
        className={
          tone === "dark"
            ? "rounded-md border-0 bg-zinc-800 py-1 ps-2 pe-7 text-xs text-zinc-200 ring-1 ring-zinc-700"
            : "rounded-md border-0 bg-white py-1 ps-2 pe-7 text-xs text-zinc-700 ring-1 ring-zinc-200"
        }
      >
        {UI_LOCALES.map((l) => (
          <option key={l} value={l} lang={l}>
            {UI_LOCALE_NAMES[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
